import { render, staticRenderFns } from "./EditContentModal.vue?vue&type=template&id=396a1149&scoped=true"
import script from "./EditContentModal.vue?vue&type=script&lang=js"
export * from "./EditContentModal.vue?vue&type=script&lang=js"
import style0 from "./EditContentModal.vue?vue&type=style&index=0&id=396a1149&prod&scoped=true&lang=css"
import style1 from "./EditContentModal.vue?vue&type=style&index=1&id=396a1149&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a1149",
  null
  
)

export default component.exports